import { useTranslation } from "react-i18next";

export const useRTL = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  return { t, isRTL };
};

//   const { t, isRTL } = useRTL();   how to use it
